import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { getResponsiblePersons } from "../external-sources/ResponsiblePersons";
import { SchemaContext } from "../../common";
import { Modes } from "./mode";

export const createResponsiblePerson = (context: SchemaContext): FieldSchema => ({
  grid: {
    displayed: true,
    order: 9,
    filter: GridFilterTypes.SET,
    // Set filter without a `data` enum: the form resolves people through the user lookup,
    // so the filter's options are grid-scoped.
    filterValues: { getter: () => getResponsiblePersons(context.client) },
  },
  name: "responsiblePerson",
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: {
    label: "Equipment Responsible",
    disabled: {
      getter: ({ linkedInstance, mode, currentUser }) => {
        return (
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["linkedInstance", "mode", "currentUser"],
    },
  },
});
